// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__TQsAc","actionsCol":"EnrolledClinics_actionsCol__1Amfi"};